import { useTranslation } from "react-i18next";

export const useFormRules = () => {
  const { t } = useTranslation();

  return {
    REQUIRED: {
      required: true,
      message: t("form:validateMessages.required"),
    },
  };
};
